<template lang="pug">
  v-icon.pt-2(medium data-cy="action-type-icon") {{ icon }}
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
    },
    dataKey: {
      type: String,
    },
    type: {
      type: String,
      default: null,
    },
  },
  computed: {
    item() {
      const { type, data, dataKey } = this;
      if (type) {
        return type;
      }
      return data[dataKey];
    },
    icon() {
      switch (this.item) {
        case 'Call Contact':
          return 'phone';
        case 'Text Contact':
        case 'send_sms_scheduled':
          return 'tablet_android';
        case 'Email Contact':
        case 'send_email_scheduled':
          return 'email';
        case 'Direct Mail: Letter':
        case 'Direct Mail: Postcard':
          return 'send';
        case 'Agent Task - Email Reminder':
        case 'Agent Task - Call Reminder':
        case 'Agent Task - Text Reminder':
        case 'Agent Task - No Reminder':
          return 'playlist_add_check';
        default:
          break;
      }
    },
  },
};
</script>
